var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"config":_vm.editorConfig,"editor":_vm.editor,"disabled":_vm.editorDisabled},on:{"ready":_vm.onEditorReady,"focus":_vm.onEditorFocus,"blur":_vm.onEditorBlur,"input":_vm.onEditorInput,"destroy":_vm.onEditorDestroy},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }